/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  Condition,
  ErrorResponse,
  ProductActivityResponseDataResponse,
  ProductLookupRequest,
  ProductLookupResponseDataResponse,
  ProductOverviewResponseCollectionResponse,
  ProductResponseCollectionResponse,
  SaleMonthlyOverviewResponseCollectionResponse,
  SkuSizeResponseCollectionResponse,
  Sorting,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class Products<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Products
   * @name ProductsList
   * @request GET:/Products
   * @response `200` `ProductResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  productsList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProductResponseCollectionResponse, ErrorResponse>({
      path: `/Products`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Products
   * @name GetProductActivity
   * @request GET:/Products/{id}/Activity
   * @response `200` `ProductActivityResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getProductActivity = (id: number, params: RequestParams = {}) =>
    this.http.request<ProductActivityResponseDataResponse, ErrorResponse>({
      path: `/Products/${id}/Activity`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Products
   * @name GetProductMonthlySalesWithinMonthsRange
   * @request GET:/Products/{id}/MonthlySales/MonthsRange/{monthsRange}
   * @response `200` `SaleMonthlyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getProductMonthlySalesWithinMonthsRange = (
    id: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<SaleMonthlyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Products/${id}/MonthlySales/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Products
   * @name GetRegionProductMonthlySalesWithinMonthsRange
   * @request GET:/Products/{id}/Regions/{regionId}/MonthlySales/MonthsRange/{monthsRange}
   * @response `200` `SaleMonthlyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getRegionProductMonthlySalesWithinMonthsRange = (
    id: number,
    regionId: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<SaleMonthlyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Products/${id}/Regions/${regionId}/MonthlySales/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Products
   * @name ProductOverviews
   * @request GET:/Products/{id}/Overviews
   * @response `200` `ProductOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  productOverviews = (id: number, params: RequestParams = {}) =>
    this.http.request<ProductOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Products/${id}/Overviews`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Products
   * @name ProductSkusSizes
   * @request GET:/Products/{id}/Skus/Sizes
   * @response `200` `SkuSizeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  productSkusSizes = (
    id: number,
    query?: {
      /** @format int64 */
      storeId?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SkuSizeResponseCollectionResponse, ErrorResponse>({
      path: `/Products/${id}/Skus/Sizes`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Products
   * @name LookupProducts
   * @request POST:/Products/Lookup
   * @response `200` `ProductLookupResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  lookupProducts = (data: ProductLookupRequest, params: RequestParams = {}) =>
    this.http.request<ProductLookupResponseDataResponse, ErrorResponse>({
      path: `/Products/Lookup`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
